import '@angular/fire/functions';
import 'rxjs';
import 'rxjs/operators';
import '@angular/fire/firestore';
import { cacheConverter, DefaultDataConverter } from '../base/DefaultDataConverter.js';
import { Page } from '@yoimo/interfaces/validators';
class PageDataConverter extends DefaultDataConverter {
  constructor() {
    super(Page);
  }
}
const converter = cacheConverter(PageDataConverter);
export { PageDataConverter, converter };
